/** Redis / API view keys */
export const DASHBOARD_MENU_SLIDE = 'dashboard-menu-slide'
export const KEY_DEMO2 = 'key-demo2'
export const COLLECTIONS = 'collections'
export const CATEGORIES_LIST_ALL = 'categories-list-all'
export const USER_LIST_ALL = 'user-list-all'
export const BLOGS_LIST_ALL = 'blogs-list-all'
export const CLIENT_CATEGORY_PRODUCUT_TOP = 'client-category-producut-top'
export const NEWS_DETAIL = 'news-detail'
export const PRODUCTS_LIST_ALL2 = 'products-list-all2'
export const CLIENT_CATEGORY_LIST = 'client-category-list'
export const COLLECTION_HOME = 'collection-home'
export const MENU_TOP_HEADER = 'menu-top-header'
export const PRODUCT_CATEGORIES = 'product-categories'
export const HOME_BANNER_TOP = 'home-banner-top'
export const PRODUCTS_LIST_ALL = 'products-list-all'
export const NEWS_LIST_ALL = 'news-list-all'
export const HOME_PRO_CAT = 'home-pro-cat'
export const COLOR_LIST = 'color-list'
export const HOME_PRO_CAT_TEST = 'home-pro-catTest'
export const PRODUCT_PRICE_SEARCH = 'product-price-search'
export const DEFAULT_FOTTER = 'default-fotter'
export const COMPANY_INFOR = 'company-infor'
export const DEFAULT_MENU_HEADER = 'default-menu-header'
export const PROFILE_BLOGS_TYPE = 'profile-blogs-type'
export const STORE_INFORMATION = 'store-information'
export const ADMIN_SLIDE_MENU = 'admin-slide-menu'
export const PRODUCT_DETAIL = 'product-detail'
export const MANAGER_SIDER_BAR = 'manager-sider-bar'
export const CUSTOMER_MENU_INFO = 'customer-menu-infom'
export const CUSTOMER_MENU_BUILDING = 'customer-menu-building'